import { FC } from "react";

const TwitterIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    className={className}
  >
    <path
      d="M23 1.22002C22.0424 1.89549 20.9821 2.41213 19.86 2.75002C19.2577 2.05753 18.4573 1.56671 17.567 1.34394C16.6767 1.12118 15.7395 1.17721 14.8821 1.50447C14.0247 1.83173 13.2884 2.41442 12.773 3.17373C12.2575 3.93305 11.9877 4.83235 12 5.75002V6.75002C10.2426 6.79558 8.50127 6.40583 6.93101 5.61546C5.36074 4.8251 4.01032 3.65865 3 2.22002C3 2.22002 -1 11.22 8 15.22C5.94053 16.618 3.48716 17.3189 1 17.22C10 22.22 21 17.22 21 5.72002C20.9991 5.44147 20.9723 5.16361 20.92 4.89002C21.9406 3.88351 22.6608 2.61273 23 1.22002Z"
      fill="#1DA1F2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TwitterIcon;
